module.exports = __webpack_public_path__ + "static/media/91.232e964c.wav";